//idcard脱敏
export  const idCardChange = (value) =>{
    if(value){
        return value.replace(/(\w{6})\w*(\w{4})/, '$1********$2')
    }else{
        return '--'
    }  
}

//mobile脱敏
export const mobile = (value) =>{
    if(value){
        return value.replace(/(\w{3})\w*(\w{4})/,'$1****$2')
    }else{
        return '--'
    }
}

//时间
export const dateTime = (value,index) =>{
    if(value && value !== '0' && value != '86430'){
        var date = new Date(value*1000) //时间戳为10位需*1000，时间戳为13位的话不需乘1000
        var Y = date.getFullYear() + '-'
        var M = (date.getMonth()+1 < 10 ? '0'+(date.getMonth()+1) : date.getMonth()+1) + '-'
        var D = date.getDate() < 10 ? '0'+date.getDate() : date.getDate() 
        if(index){
            var h = ' '+(date.getHours() < 10 ? '0'+date.getHours() : date.getHours()) + ':'
            var m = (date.getMinutes() < 10 ? '0'+date.getMinutes() : date.getMinutes()) + ':'
            var s = date.getSeconds() < 10 ? '0'+date.getSeconds() : date.getSeconds()
            return Y+M+D+h+m+s
        }else{
            return Y+M+D
        }
    }else{
        return '--'
    }
}

//小数点
export const numFilter = (value,index) => {
    // 截取当前数据到小数点后三位
    let i = parseInt(index)
    let tempVal = parseFloat(value).toFixed(i)
    let realVal = tempVal.substring(0,  tempVal.length - 1)
    return realVal
}

//银行卡号
export  const BankCard = (value) =>{
    if(value){
        return value.replace(/(\w{6})\w*(\w{4})/, '$1********$2')
    }else{
        return '--'
    }  
}

//居住地址
export  const AddRess = (value) =>{
    if(typeof value == 'string' && value != ''){
        let ruten = value.substring(6);
        return value.replace(ruten,'************');
    } else {
        return '--'
    }
}

//姓名提取
export  const CaseName = (value) =>{
    if(typeof value == 'string'){
        let ruten = value.substring(1);
        return value.replace(ruten,'**');
    }
}

//性别提取
export const distillSex = (value) => {   
    let res = '';
    let len = 0;
    if (value != '' && value != undefined) {
        len = value.length;
        if (len == 15) {
            res = value.substring(14,15)
        } else {
            res = value.substring(16,17)
        }
    }           
    return res % 2 == 0 ? '女' : '男';
}

//委托方转中文
export  const EntrustsNo = (value) =>{
    let Entrusts = JSON.parse(sessionStorage.getItem('entrustsAll'));
    for (var key in Entrusts) {
        if (value == Entrusts[key]['id']) {
            return Entrusts[key]['name'];
        }
    }
}

//金额万位制
export const Money = (value) =>{
    if(value){
        return (value / 10000).toFixed(2)
    }else{
        return 0
    }
}

/**
 * 将数字格式化为带有千位分隔符和固定小数位数的字符串。
 * @param {number|string} num - 要格式化的输入数字
 * @param {number} [fixed=2] - 要保留的小数位数。
 * @returns {string} 带有千位分隔符和固定小数位数的格式化数字。
 */
export const toThousands = (num, fixed = 2, nullDefault) => {
    if (!num || num === '') return nullDefault || '0.00';
    if (num === '--') return nullDefault || '--';
    if (Number(num) === NaN) return num;
    if (Number(num) === 0) return nullDefault || num

    const strNum = String(num);
    const [integerPart, decimalPart = '00'] = strNum.split('.');
    const formattedInteger = integerPart.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    let formattedDecimal = decimalPart.padEnd(2, '0').slice(0, fixed);
    // 如果小数点保留3位，小数点不够三位，则补充三位
    if (formattedDecimal.length < fixed) {
        let gap = fixed - formattedDecimal.length;
        for (let index = 0; index < gap; index++) {
            formattedDecimal += '0'
        }
    }
    return `${formattedInteger}.${formattedDecimal}`;
};

//秒转换成时分秒
export const MinutesChange = (val, type = 'c') => {
    let time = Number(val)
    if (isNaN(time)) {
        return
    }
    let h, m, s;
    if (time > 60) {
        m = parseInt(time/60)
        s = time%60
        if (m > 60) {
            h = parseInt(m/60)
            m = m%60
        }
        if (type !== 'c') {
            h = h > 0 ? (h > 9 ? h + ':' : `0${h}:`) : '00:';
            m = m > 0 ? (m > 9 ? m + ':' : `0${m}:`) : '00:';
            s = s > 0 ? (s > 9 ? s : `0${s}`) : '00';
        } else {
            h = h > 0 ? h + '时' : '';
            m = m > 0 ? m + '分' : (s > 0 ? '0分' : '');
            s =  s > 0 ? s + '秒' : '';
        }
            
        return h+m+s
    } else if (time <= 0) {
        if (type !== 'c') {
            return '00:00:00'
        }
        return 0
    } else {
        if (type !== 'c') {
            return '00:00:' + (time > 9 ? time : `0${time}`)
        }
        return time + '秒'
    }
}


// WEBPACK FOOTER //
// ./src/api/filter.js